module.exports = __webpack_public_path__ + "img/arright.cca75b9b.png";